import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import VideoCategoryPage from "@/pages/video-category/page";
import ImageCategoryPage from "@/pages/image-category/page";
import NewsCategoryPage from "@/pages/news-category/page";
import VideoDetailPage from "@/pages/video-detail/page";
import ImageDetailPage from "@/pages/image-detail/page";
import NewsDetailPage from "@/pages/news-detail/page";
import CommunityPage from "@/pages/community/page";
import CommunityDetailPage from "@/pages/community-detail/page";
import AboutPage from "@/pages/about/page";
import SearchPage from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "video-category", element: <VideoCategoryPage /> },
      { path: "image-category", element: <ImageCategoryPage /> },
      { path: "news-category", element: <NewsCategoryPage /> },
      { path: "video-detail/:id", element: <VideoDetailPage /> },
      { path: "image-detail/:id", element: <ImageDetailPage /> },
      { path: "news-detail/:id", element: <NewsDetailPage /> },
      { path: "community", element: <CommunityPage /> },
      { path: "community-detail/:id", element: <CommunityDetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;